import React, { Component } from "react";
import { FormGroup, Glyphicon } from "react-bootstrap";
import styles from "./AdminReferralCodes.scss";
import AdminTable from "../../../../../components/common/table/AdminTable";
import moment from "moment";

const tableColumns = [
  {
    headerText: "CODE ID",
    accessor: "code"
  },
  {
    headerText: "DATE CREATED",
    accessor: "created_at"
  },
  {
    headerText: "STATUS",
    accessor: "status"
  },
  {
    headerText: "USERS",
    accessor: "users_count"
  }
];

const subTableColumns = [
  {
    headerText: "NAME",
    accessor: "user_name"
  },
  {
    headerText: "DATE CREATED",
    accessor: "created_at"
  },
  {
    headerText: "COMPANY",
    accessor: "company_name"
  }
];

class AdminReferralCodes extends Component {
  getTableData(referralCodes) {
    let data = referralCodes.map(refCode => {
      return {
        id: refCode.id,
        code: refCode.code,
        created_at: moment(refCode.created_at).format("MMMM DD, YYYY"),
        status: refCode.active ? "Active" : "Inactive",
        users_count: _.get(refCode, "users").length,
        users: _.get(refCode, "users")
      };
    });

    return data;
  }

  getSubTableData(users) {
    if (!users) {
      return [];
    }

    let data = users.map(user => {
      return {
        user_name: `${_.get(user, "user.first_name")} ${_.get(
          user,
          "user.last_name"
        )}`,
        created_at: moment(user.created_at).format("MMMM DD, YYYY"),
        company_name: _.get(user, "user.profile.company.name")
      };
    });

    return data;
  }

  render() {
    const { referralCodes, loadingCodes } = this.props;

    return (
      <section className={styles.adminReferralCodes}>
        <div className={styles.content}>
          <h2 className={styles.title}>Manage Referral Codes</h2>
          <div className={styles.form}>
            <FormGroup>
              <div className={styles.subtitle}>
                Here are the codes you've created that allow new Company Users
                to bypass the credit card authentication / verification form in
                the signup flow.
              </div>
            </FormGroup>

            <div className={styles.dividerDouble} />

            {referralCodes && (
              <div className={styles.tableContainer}>
                <AdminTable
                  tableData={this.getTableData(referralCodes)}
                  tableColumns={tableColumns}
                  loading={loadingCodes}
                  selectable={false}
                  noRowsText="No referral codes found"
                  expandible={true}
                  subcomponent={row => {
                    const users = row.original.users;
                    const id = row.original.id;
                    const active = row.original.status == "Active";
                    return (
                      <div className={styles.subtableContainer}>
                        {users && users.length > 0 && (
                          <AdminTable
                            tableData={this.getSubTableData(users)}
                            tableColumns={subTableColumns}
                            selectable={false}
                            expandible={false}
                            noRowsText="No users found"
                          />
                        )}
                        {active ? (
                          <div className={styles.actionContainer}>
                            <Glyphicon glyph="pause" className={styles.icon} />
                            <a
                              onClick={() =>
                                this.props.updateReferralCode(id, false)
                              }
                            >
                              Deactivate Code
                            </a>
                          </div>
                        ) : (
                          <div className={styles.actionContainer}>
                            <Glyphicon glyph="play" className={styles.icon} />
                            <a
                              onClick={() =>
                                this.props.updateReferralCode(id, true)
                              }
                            >
                              Activate Code
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  }}
                />
                <div className={styles.actionContainer}>
                  <Glyphicon glyph="plus" className={styles.icon} />
                  <a onClick={() => this.props.createReferralCode()}>
                    Create New Code
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default AdminReferralCodes;



// WEBPACK FOOTER //
// ./src/routes/admin/new/referralCodes/components/AdminReferralCodes.js